import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import FormGridItem from '~/components/FormComponents/FormGridItem.tsx';
import { Box, Grid, Typography } from '@mui/material';
import { FormRadioGroup } from '~/components/FormComponents/FormRadioGroup.tsx';
import { FatcaStatusOptions } from '~/modules/identification/forms/FatcaAdditionalInformation/constants/constants.ts';
import { commonStyles } from '~/theme/styles/commonStyles';
import { InfoTooltip } from '~/components/InfoTooltip/InfoTooltip.tsx';
import { informerUsEntityInfo } from '~/modules/identification/forms/FatcaAdditionalInformation/constants/informers.tsx';

export const UsEntityInfo = () => {
  const basePath = `usEntityInfo`;

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormInput
          name={`${basePath}.clientFullName`}
          label="Повне найменування клієнта"
          placeholder="Введіть повне найменування клієнта"
          disabled
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`${basePath}.clientFullNameEng`}
          label="Повне найменування (англійською)"
          placeholder="Введіть повне найменування (англійською)"
          fullWidth
        />
      </FormGridItem>
      <Box sx={{ ...commonStyles.centerFlexContainer, gap: 1 }}>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          Вкажіть, будь ласка, ідентифікаційний номер платника податків США (TIN (EIN)),
          FATCA-статус та найменування англійською мовою Вашої установи та надайте заповнену форму
          W-9
        </Typography>
        <InfoTooltip title={informerUsEntityInfo} />
      </Box>
      <FormInput
        name={`${basePath}.tinEin`}
        label="Ідентифікаційний номер платника податків США (TIN (EIN))"
        placeholder="Введіть ідентифікаційний номер платника податків США (TIN (EIN))"
        fullWidth
      />
      <FormRadioGroup
        name={`${basePath}.fatcaStatus`}
        options={FatcaStatusOptions}
        label={
          <Typography variant="body1" sx={{ ...commonStyles.centerFlexContainer, gap: 0.5 }}>
            Вкажіть статус Вашої установи відповідно до законодавства FATCA
          </Typography>
        }
      />
    </Grid>
  );
};
